import {ReactNode} from "react";

import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import {FilterCategory, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {ChecksFilters} from "@/pages/checks/list/components/ChecksFilters.tsx";

interface ChecksControlBarProps {
  search: string;
  setSearch: (search: string) => void;
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
  portal?: boolean;
  right?: ReactNode;
  disabled?: boolean;
  disabledTooltip?: string;
}

export const ChecksControlBar = ({
  search,
  setSearch,
  filterSets,
  onFilterSetChange,
  portal,
  right,
  disabled,
  disabledTooltip,
}: ChecksControlBarProps) => {
  return (
    <ActionBarWrapper
      className="mb-3"
      left={
        <>
          <SearchInput value={search} onChange={setSearch} variant="tableControlBar" />
          <ChecksFilters
            filterSets={filterSets}
            onFilterSetChange={onFilterSetChange}
            portal={portal}
            disabled={disabled}
            disabledTooltip={disabledTooltip}
          />
        </>
      }
      right={right}
    />
  );
};
